export default "__VITE_ASSET__DxK7wmY$__"